import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface ContentProps extends PropsWithChildren {
  className?: string;
}

export const Content = ({ children, className }: ContentProps) => {
  return (
    <div
      className={twMerge(
        'flex w-full flex-1 flex-col items-center justify-center gap-6 px-4',
        className,
      )}
    >
      {children}
    </div>
  );
};
